import React from "react";
import "./projects.css";


import Project from "./Project";
import data from "../../data/data";

const Projects = () => {
    return (
        <section className="app__projects d-flex flex-item-center">
            <div className="app__projects-container app__container">
                <div className="app__projects-header">
                    <h2> Projects & Portfolio </h2>
                    <h3> Explore Some <span> interesting projects </span> that i have done over the years. </h3>
                </div>
                <div className="app__projects-body">
                    <div className="app__projects-row -grid gap-2">
                        { data.projects.slice(0,6).map(project => (
                            <Project 
                                key={project.id}
                                data={project}
                            />
                        ))}
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Projects;